<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container big-container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Corporate</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Customer
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Customer <span><i class="ic-office"></i></span>
                  </h2>
                  <p>Manage your customers and booker details.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container big-container">
        <div class="row mb-20">
          <div class="col-sm-4">
            <label for="">Company</label>
            <v-select
              @input="getAll()"
              class="v-search-select"
              placeholder="Company"
              label="name"
              v-model="table.companyIds"
              :options="companies"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.id"
            />
          </div>
          <div class="col-sm-4">
            <label>Type</label>
            <v-select
              @input="getAll()"
              class="v-search-select"
              placeholder="Type"
              label="text"
              v-model="table.type"
              :options="typeOptions"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.value"
            />
          </div>
          <div class="col-sm-4">
            <label for="search">Search</label>
            <div class="dataTables_filter" id="filter-search">
              <i class="ic-search"></i>
              <input
                id="search"
                type="search"
                class="form-control"
                placeholder="Search"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-p15">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>
                    Company
                    <span
                      class="button-sort"
                      @click="onClickSort('company_name')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>
                    Customer
                    <span
                      class="button-sort"
                      @click="onClickSort('customer_name')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th class="text-center">Type</th>
                  <th class="text-left">Status</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.companyName }}</td>
                  <td>
                    {{ item.title ? `${item.title}.` : "" }}
                    {{ item.fullName }}
                  </td>
                  <td>
                    <span :class="{ 'sts-danger': item.phones.length === 0 }">{{
                      printPhone(item.phones)
                    }}</span>
                  </td>
                  <td>
                    <span :class="{ 'sts-danger': item.emails.length === 0 }">{{
                      printEmail(item.emails)
                    }}</span>
                  </td>
                  <td class="text-center">
                    Corp. {{ item.isAdmin ? "Admin" : "Booker" }}
                  </td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="dropdown">
                      <button
                        class="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <img
                          src="/static/assets/images/three-dots.svg"
                          alt="three-dots-options"
                          width="15"
                        />
                      </button>
                      <ul
                        class="dropdown-menu dropdown-invoice-options"
                        aria-labelledby="dropdownMenu1"
                      >
                        <li v-if="isAllowToUpdate">
                          <a @click="updateItem(item)">Edit</a>
                        </li>
                        <li v-if="!item.isSync && isAllowToSync">
                          <a @click="openAuthModal(item)">Sync</a>
                        </li>
                        <li v-if="isAllowToDelete">
                          <a @click="confirmDelete(item)">Delete</a>
                        </li>
                        <li><a @click="openCardModal(item)">Cards</a></li>
                        <li>
                          <a @click="openTokenizationLinkModal(item.id)"
                            >Tokenization Link</a
                          >
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="customermodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Customer</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <ul
                    class="nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"
                  >
                    <li :class="[activeTab === 'general' ? 'active' : '']">
                      <a
                        href="#customer-general"
                        data-toggle="tab"
                        @click="activeTab = 'general'"
                      >
                        <span class="required">General</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'contact' ? 'active' : '']">
                      <a
                        href="#customer-contact"
                        data-toggle="tab"
                        @click="activeTab = 'contact'"
                      >
                        <span class="required">Contact</span>
                      </a>
                    </li>
                  </ul>
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="tab-content">
                      <div
                        id="customer-general"
                        class="tab-pane fade"
                        :class="[activeTab === 'general' ? 'in active' : '']"
                      >
                        <div class="form-group">
                          <label class="required">Company</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.companyId.$error,
                            }"
                            placeholder=""
                            label="name"
                            v-model="model.companyId"
                            :options="companies"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.id"
                          >
                          </v-select>
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.companyId.required"
                            >Company is required</small
                          >
                        </div>
                        <div class="form-group">
                          <label>Select Title</label>
                          <div
                            class="btn-group btn-group-toggle"
                            data-toggle="buttons"
                          >
                            <label
                              class="btn"
                              :class="{
                                active: model.title === item.value,
                                'field-error':
                                  isSubmitted && $v.model.title.$error,
                              }"
                              v-for="(item, index) in titles"
                              :key="index"
                              @click="model.title = item.value"
                            >
                              <input
                                type="radio"
                                name="title"
                                autocomplete="off"
                                :value="item.value"
                                :checked="model.title === item.value"
                                v-model="model.title"
                              />
                              {{ item.text }}
                            </label>
                          </div>
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.title.required"
                            >Title is required</small
                          >
                        </div>
                        <div class="form-group" v-if="model.title === 'Other'">
                          <label class="">Title</label>
                          <input
                            type="text"
                            class="form-control alphabets-only"
                            v-model="model.otherTitle"
                            autocomplete="off"
                          />
                        </div>
                        <div class="form-group">
                          <label class="required">Full Name</label>
                          <input
                            type="text"
                            class="form-control alphabets-only"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.fullName.$error,
                            }"
                            autocomplete="off"
                            v-model="model.fullName"
                          />
                          <div v-if="isSubmitted && $v.model.fullName.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.fullName.required"
                              >Full Name is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.fullName.maxLength"
                              >Full Name must be less than
                              {{ $v.model.fullName.$params.maxLength.max }}
                              characters</small
                            >
                          </div>
                        </div>
                        <div class="form-group" v-if="!isUpdate">
                          <label>Password</label>
                          <input
                            type="password"
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.password.$error,
                            }"
                            autocomplete="off"
                            v-model="model.password"
                          />
                          <div v-if="isSubmitted && $v.model.password.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.password.maxLength"
                              >Password must be less than
                              {{ $v.model.password.$params.maxLength.max }}
                              characters</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Is Admin?</label>
                          <label class="cursor-pointer w-max-content">
                            <input
                              type="radio"
                              class="control-radio"
                              name="isAdminFlagNo"
                              value="false"
                              :checked="model.isAdmin == false"
                              v-model="model.isAdmin"
                            />
                            <span class="pl-5 font-weight-normal v-align-middle"
                              >No</span
                            >
                          </label>
                          <label class="cursor-pointer w-max-content">
                            <input
                              type="radio"
                              class="control-radio"
                              name="isAdminFlagYes"
                              value="true"
                              :checked="model.isAdmin == true"
                              v-model="model.isAdmin"
                            />
                            <span class="pl-5 font-weight-normal v-align-middle"
                              >Yes</span
                            >
                          </label>
                        </div>
                        <div class="form-group">
                          <label>Is Person In Charge?</label>
                          <label class="cursor-pointer w-max-content">
                            <input
                              type="radio"
                              class="control-radio"
                              name="isPersonInChargeNo"
                              value="false"
                              :checked="model.isPersonInCharge == false"
                              v-model="model.isPersonInCharge"
                            />
                            <span class="pl-5 font-weight-normal v-align-middle"
                              >No</span
                            >
                          </label>
                          <label class="cursor-pointer w-max-content">
                            <input
                              type="radio"
                              class="control-radio"
                              name="isPersonInChargeYes"
                              value="true"
                              :checked="model.isPersonInCharge == true"
                              v-model="model.isPersonInCharge"
                            />
                            <span class="pl-5 font-weight-normal v-align-middle"
                              >Yes</span
                            >
                          </label>
                        </div>
                        <div class="form-group">
                          <label>Preferred Location</label>
                          <input
                            type="text"
                            class="form-control"
                            name="location_name"
                            autocomplete="off"
                            v-model="location.name"
                          />
                        </div>
                        <div class="form-group">
                          <label for>Address</label>
                          <textarea
                            class="form-control"
                            rows="4"
                            name="location_address"
                            autocomplete="off"
                            v-model="location.address"
                          ></textarea>
                        </div>
                        <button
                          type="button"
                          id="btn-map"
                          class="btn btn-default"
                          @click.prevent="openMapModal()"
                        >
                          <i class="ic-map"></i>
                          Select Location by Map
                        </button>
                      </div>
                      <div
                        id="customer-contact"
                        class="tab-pane fade"
                        :class="[activeTab === 'contact' ? 'in active' : '']"
                      >
                        <!-- Start: Phone -->
                        <div>
                          <h4>Phone</h4>
                          <div
                            class="row"
                            v-for="(item, index) in model.modifiedPhones"
                            :key="index"
                          >
                            <div v-if="item.state !== 'Deleted'">
                              <div class="col-sm-12">
                                <label class="required">Phone</label>
                                <div class="row">
                                  <div class="col-sm-5">
                                    <div class="form-group">
                                      <v-select
                                        class="v-search-select"
                                        :class="{
                                          'field-error':
                                            isSubmitted &&
                                            $v.model.modifiedPhones.$each[index]
                                              .code.$error,
                                        }"
                                        placeholder=""
                                        label="label"
                                        v-model="item.code"
                                        :options="phoneCodes"
                                        :filter="searchPhoneCode"
                                        :clearable="true"
                                        :searchable="true"
                                        :filterable="true"
                                        :reduce="(option) => option.dial"
                                        @input="onChangeCustomerItem(item)"
                                      >
                                        <template
                                          slot="option"
                                          slot-scope="option"
                                        >
                                          <div class="phone-wrapper">
                                            <div
                                              class="phone-icon"
                                              :class="option.icon"
                                            ></div>
                                            <div class="phone-text">
                                              {{ option.country }}
                                            </div>
                                          </div>
                                        </template>
                                      </v-select>
                                      <small
                                        class="form-text sts-danger"
                                        v-if="
                                          isSubmitted &&
                                          !$v.model.modifiedPhones.$each[index]
                                            .code.required
                                        "
                                        >Phone Code is required</small
                                      >
                                    </div>
                                  </div>
                                  <div class="col-sm-7">
                                    <div class="form-group">
                                      <input
                                        type="text"
                                        class="form-control numbers-only"
                                        :class="{
                                          'field-error':
                                            isSubmitted &&
                                            $v.model.modifiedPhones.$each[index]
                                              .number.$error,
                                        }"
                                        autocomplete="off"
                                        v-model="item.number"
                                        @keyup="onChangeCustomerItem(item)"
                                      />
                                      <div
                                        v-if="
                                          isSubmitted &&
                                          $v.model.modifiedPhones.$each[index]
                                            .number.$error
                                        "
                                      >
                                        <small
                                          class="form-text sts-danger"
                                          v-if="
                                            !$v.model.modifiedPhones.$each[
                                              index
                                            ].number.required
                                          "
                                          >Phone Number is required</small
                                        >
                                        <small
                                          class="form-text sts-danger"
                                          v-if="
                                            !$v.model.modifiedPhones.$each[
                                              index
                                            ].number.maxLength
                                          "
                                          >Phone Number must be less than
                                          {{
                                            $v.model.modifiedPhones.$each[index]
                                              .number.$params.maxLength.max
                                          }}
                                          characters</small
                                        >
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-12">
                                    <div class="form-group">
                                      <button
                                        v-if="
                                          model.modifiedPhones &&
                                          model.modifiedPhones.length > 0
                                        "
                                        type="button"
                                        class="btn btn-default sts-danger"
                                        @click.prevent="removePhone(index)"
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="phoneCodes && model.modifiedPhones"
                          >
                            <div class="col-sm-12">
                              <button
                                v-if="model.modifiedPhones"
                                type="button"
                                class="btn btn-default"
                                @click.prevent="addPhone()"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- End: Phone -->
                        <!-- Start: Email -->
                        <div style="padding-top: 20px">
                          <h4>Email</h4>
                          <div
                            class="row"
                            v-for="(item, index) in model.modifiedEmails"
                            :key="index"
                          >
                            <div v-if="item.state !== 'Deleted'">
                              <div class="col-sm-12">
                                <label class="required">Email</label>
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.modifiedEmails.$each[index]
                                          .email.$error,
                                    }"
                                    v-model="item.email"
                                    autocomplete="off"
                                    @keyup="onChangeCustomerItem(item)"
                                  />
                                  <div
                                    v-if="
                                      isSubmitted &&
                                      $v.model.modifiedEmails.$each[index].email
                                        .$error
                                    "
                                  >
                                    <small
                                      class="form-text sts-danger"
                                      v-if="
                                        !$v.model.modifiedEmails.$each[index]
                                          .email.required
                                      "
                                      >Email is required</small
                                    >
                                    <small
                                      class="form-text sts-danger"
                                      v-if="
                                        !$v.model.modifiedEmails.$each[index]
                                          .email.email
                                      "
                                      >Email is invalid</small
                                    >
                                    <small
                                      class="form-text sts-danger"
                                      v-if="
                                        !$v.model.modifiedEmails.$each[index]
                                          .email.maxLength
                                      "
                                      >Email must be less than
                                      {{
                                        $v.model.modifiedEmails.$each[index]
                                          .email.$params.maxLength.max
                                      }}
                                      characters</small
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <button
                                    v-if="
                                      model.modifiedEmails &&
                                      model.modifiedEmails.length > 0
                                    "
                                    type="button"
                                    class="btn btn-default sts-danger"
                                    @click.prevent="removeEmail(index)"
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="model.modifiedEmails">
                            <div class="col-sm-12">
                              <button
                                type="button"
                                class="btn btn-default"
                                @click.prevent="addEmail()"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- End: Email -->
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="customerpasswordmodal">
      <div class="modal-dialog modal-xs">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Customer Authentication</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form @submit.prevent="submitAuth()">
                    <div class="form-group">
                      <label class="required">Password</label>
                      <input
                        type="password"
                        autocomplete="off"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.auth.password.$error,
                        }"
                        v-model="auth.password"
                      />
                      <div v-if="isSubmitted && $v.auth.password.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.auth.password.required"
                          >Password is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.auth.password.maxLength"
                          >Password must be less than
                          {{ $v.auth.password.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        Save Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header modal-new" :class="{ update: isUpdate }">
          <div class="row">
            <div class="col-sm-10">
              <h4>Customer Location</h4>
              <h6 v-if="model.modifiedDate">
                Last Updated: {{ model.modifiedDate.stringFullDate }}
              </h6>
            </div>
            <div class="col-sm-2">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i class="ic-close"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <div class="gmap-wrapper">
              <div class="pac-card" id="pac-card">
                <div id="pac-container">
                  <input
                    id="pac-input"
                    type="text"
                    placeholder="Enter a location"
                  />
                </div>
              </div>
              <div id="map"></div>
              <div class="modal-footer text-center">
                <div id="gmap-custom-control">
                  <button type="button" class="btn btn-default remove-location">
                    Reset
                  </button>
                  <button type="button" class="btn btn-primary save-location">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="cardListModal">
      <div class="modal-dialog modal-base">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Cards</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="flex-column gap-20 mb-60">
                    <div
                      class="d-flex justify-between card-list-wrapper"
                      :class="{
                        'bg-gray-ddd': isExpired(
                          item.expiryMonth,
                          item.expiryYear
                        ),
                      }"
                      v-for="(item, index) in paymentList"
                      :key="index"
                    >
                      <div class="d-flex" style="gap: 20px">
                        <div class="img-card-logo">
                          <img
                            :src="
                              item.brand === 'VISA'
                                ? '/static/assets/images/credit-card-logo/visa-logo.svg'
                                : item.brand === 'JCB'
                                ? '/static/assets/images/credit-card-logo/jcb-logo.svg'
                                : item.brand === 'AMEX'
                                ? '/static/assets/images/credit-card-logo/amex-logo.svg'
                                : item.brand === 'Mastercard'
                                ? '/static/assets/images/credit-card-logo/mastercard-logo.svg'
                                : item.brand === 'Diners Club International'
                                ? '/static/assets/images/credit-card-logo/diners-logo.svg'
                                : item.brand === 'Discover'
                                ? '/static/assets/images/credit-card-logo/discover-logo.svg'
                                : '/static/assets/images/credit-card-logo/unionpay-logo.svg'
                            "
                            alt="card-logo"
                          />
                        </div>
                        <div class="detail-card-logo flex-column">
                          <div class="credit-card-name">
                            {{
                              item.cardHolderName ? item.cardHolderName : "N/A"
                            }}
                          </div>
                          <div class="credit-card-number">
                            **** **** **** {{ item.last4 }}
                          </div>
                          <div class="credit-card-exp">
                            expires on {{ item.expiryMonth }}/{{
                              item.expiryYear
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex justify-end gap-5">
                          <div
                            v-if="item.type"
                            :class="
                              item.type === 'Business'
                                ? 'badge-business'
                                : 'badge-personal'
                            "
                          >
                            {{ item.type }}
                          </div>
                          <div class="badge-default" v-if="item.isDefault">
                            Default
                          </div>
                          <div class="dropdown">
                            <button
                              class="btn dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <img
                                src="/static/assets/images/three-dots.svg"
                                alt="three-dots-options"
                                width="15"
                              />
                            </button>
                            <ul
                              class="dropdown-menu dropdown-credit-card-list-options"
                              aria-labelledby="dropdownMenu1"
                            >
                              <li
                                v-if="
                                  !item.isDefault &&
                                  !isExpired(item.expiryMonth, item.expiryYear)
                                "
                              >
                                <a type="button" @click="setDefaultCard(item)"
                                  >Set Default</a
                                >
                              </li>
                              <li>
                                <a type="button" @click="editCard(item)"
                                  >Edit</a
                                >
                              </li>
                              <li>
                                <a
                                  type="button"
                                  @click="openDeleteCardModal(item.id)"
                                  >Delete</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="paymentList.length === 0">
                      <div class="credit-card-svg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M21.9 21.9L2.1 2.1L.69 3.51l1.55 1.55c-.15.28-.23.6-.23.94L2 18c0 1.11.89 2 2 2h13.17l3.31 3.31l1.42-1.41zM4 12V8h1.17l4 4H4zm2.83-8H20c1.11 0 2 .89 2 2v12c0 .34-.08.66-.23.94L14.83 12H20V8h-9.17l-4-4z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </div>
                      <p class="credit-card-offline-text">
                        No credit card saved
                      </p>
                    </div>
                  </div>
                  <div class="d-flex justify-end gap-20">
                    <button
                      class="btn btn-default"
                      type="button"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button class="btn btn-primary" @click="openPaymentModal()">
                      Add New Card
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="paymentModal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Add New Card</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <FormCard
                    ref="formCard"
                    width="100%"
                    nameBtn="Save Card"
                    :customerId="selectedCustomerId"
                    :showTitle="false"
                    :awClientSecret="awClientSecret"
                    @submit="submitCardDetail()"
                  />
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="editCard">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Edit Card</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form @submit.prevent="submitEditCard()">
                    <div class="row">
                      <div class="col-sm-12 mb-20">
                        <label class="">Card Holder Name</label>
                        <input
                          type="text"
                          class="form-control alphabets-only"
                          v-model="selectedCard.cardHolderName"
                          autocomplete="off"
                        />
                      </div>
                      <div class="col-sm-12 mb-20">
                        <label class="required">Card Type</label>
                        <div class="d-flex">
                          <label
                            class="cursor-pointer"
                            v-for="(item, index) in cardType"
                            :key="index"
                            @click="selectedCard.type = item.value"
                            :class="{ 'pl-20': index > 0 }"
                          >
                            <input
                              type="radio"
                              class="control-radio"
                              :value="item.value"
                              :checked="selectedCard.type === item.value"
                              v-model="selectedCard.type"
                            />
                            <span
                              class="pl-5 font-weight-normal v-align-middle"
                            >
                              {{ item.text }}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-12 mb-20">
                        <div class="d-flex w-full gap-5">
                          <button
                            type="button"
                            class="btn btn-default"
                            style="width: 50%"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            class="btn btn-primary"
                            style="width: 50%"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <tokenization-link-modal />

    <deleteModal @submit="submitDelete" />
    <deleteModal
      idModal="deleteCardModal"
      subContent="Deleting a card is a non-reversible action."
      @submit="deleteCard"
    />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, email, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import FormCard from "@/components/shared/FormCard";
import companyService from "@/services/master/company/companyService.js";
import customerService from "@/services/master/customer/customerService.js";
import countryPhoneService from "@/services/master/countryPhoneService.js";
import maverickMap from "@/plugins/google/map.js";
import maverickGeocoding from "@/plugins/google/geocode.js";
import TokenizationLinkModal from "@/components/shared/TokenizationLinkModal.vue";

export default {
  components: {
    deleteModal,
    FormCard,
    TokenizationLinkModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    isAllowToSync: function () {
      return this.allPermissions.includes("Sync");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    validationRulePassword: function () {
      return !this.isUpdate ? { maxLength: maxLength(100) } : {};
    },
    validationRulePhone: function () {
      return this.model.modifiedPhones && this.model.modifiedPhones.length > 0
        ? {
            $each: {
              code: { required },
              number: { required, maxLength: maxLength(20) },
            },
          }
        : {};
    },
    validationRuleEmail: function () {
      return this.model.modifiedEmails && this.model.modifiedEmails.length > 0
        ? { $each: { email: { required, email, maxLength: maxLength(100) } } }
        : {};
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
        type: "Unspecified",
        companyIds: "",
      },
      typeOptions: [
        { value: "Unspecified", text: "All" },
        { value: "CorporateAdmin", text: "Corp. Admin" },
        { value: "CorporateBooker", text: "Corp. Booker" },
        { value: "CorporateCustomer", text: "Corp. Customer" },
      ],
      cardType: [
        { value: "Business", text: "Business" },
        { value: "Personal", text: "Personal" },
      ],
      isSubmitted: false,
      activeTab: "general",
      publicSettings: [],
      allPermissions: [],
      itemToBeDeleted: null,
      map: null,
      geocoder: null,
      items: [],
      titles: [],
      companies: [],
      defaultCompanyId: null,
      phoneCodes: [],
      isMarkerChange: false,
      model: {},
      auth: {},
      location: { name: null, address: null, latitude: null, longitude: null },
      paymentList: [],
      selectedCustomerId: null,
      selectedCard: {
        id: "",
        type: "",
        cardHolderName: "",
      },
      selectedCardId: "",
      awClientSecret: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        title: { required },
        otherTitle: {},
        companyId: { required },
        fullName: { required, maxLength: maxLength(150) },
        password: this.validationRulePassword,
        modifiedPhones: this.validationRulePhone,
        modifiedEmails: this.validationRuleEmail,
      },
      auth: {
        password: { required, maxLength: maxLength(100) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    this.publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      this.publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getCompanies();
      await this.getPhoneCodes();
      this.titles = [
        { value: "Mr", text: "Mr" },
        { value: "Mrs", text: "Mrs" },
        { value: "Ms", text: "Ms" },
        { value: "Other", text: "Others" },
      ];

      if (
        profile.defaultCompany &&
        this.companies &&
        this.companies.length > 0
      ) {
        const company = this.companies.find(
          (x) => x.id == profile.defaultCompany.id
        );
        if (company) {
          this.defaultCompanyId = company.id;
        }
      }
    }
  },
  mounted() {
    $(this.$refs.customermodal).on("hidden.bs.modal", this.closeCustomerModal);
    $(this.$refs.mapmodal).on("hidden.bs.modal", this.closeMapModal);
    $(this.$refs.paymentModal).on("shown.bs.modal", () => {
      this.$refs.formCard.resetAirwallex();
    });
    $(this.$refs.paymentModal).on("hidden.bs.modal", () => {
      this.$refs.formCard.resetAirwallex();
    });

    if (!this.map) {
      const defaultLatLng = this.$helper.extractSetting(
        this.publicSettings,
        "DefaultLatLng",
        "-6.17003832454938|106.81490242481232"
      );
      const latLng = defaultLatLng.split("|");
      const lat = parseFloat(latLng[0]);
      const lng = parseFloat(latLng[1]);

      // creates map instance
      this.map = new maverickMap({
        mapId: "map",
        lat: lat,
        lng: lng,
        marker: true,
        autocomplete: true,
        confirmLocationCallback: this.confirmLocation,
        removeLocationCallback: this.removeLocation,
        autoCompleteGetPlaceCallback: this.getPlace,
        markerChangeCallback: this.markerChange,
      });
      this.map.initialize();
    }

    if (!this.geocoder) {
      // creates geocoder instance
      this.geocoder = new maverickGeocoding();
    }
  },
  updated() {
    // subscribe message
    this.$eventBus.$on("openCustomerDeleteModal", this.openCustomerDeleteModal);
    this.$helper.collapseMenu("corporate");
    this.$helper.setNavigationClass("customer-link");
    this.$helper.alphabetsOnly();
    this.$helper.numbersOnly();
    this.$helper.disableContextMenu(".readonly");
  },
  beforeDestroy() {
    this.$eventBus.$off("openCustomerDeleteModal");
    document
      .querySelectorAll(".pac-container")
      .forEach((element) => element.remove());
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getAll();
    },
    async confirmLocation(coordinate) {
      // get place from geocoding
      if (this.isMarkerChange) {
        let geocodeResponse = await this.geocoder.geocode(coordinate);
        if (geocodeResponse !== undefined && geocodeResponse !== null) {
          this.location.address = geocodeResponse.address;
          this.location.name = geocodeResponse.name;
          this.location.latitude = geocodeResponse.latitude;
          this.location.longitude = geocodeResponse.longitude;
        }
      }
      this.$notification.success("Location saved.", { title: "Success" });
      this.closeMapModal();
    },
    removeLocation() {
      document.getElementById("pac-input").value = "";
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null,
      };
      this.$notification.success("Location removed.", { title: "Success" });
    },
    getPlace(place) {
      // get place from autocomplete
      this.isMarkerChange = false;
      this.location.name = place.name;
      this.location.address = place.formatted_address;
      this.location.latitude = place.geometry.location.lat();
      this.location.longitude = place.geometry.location.lng();
    },
    markerChange(latLng) {
      this.isMarkerChange = true;
    },
    resetModel() {
      this.isMarkerChange = false;
      this.model = {};
      this.auth = {};
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null,
      };
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.auth.$reset();
    },
    searchPhoneCode(options, search) {
      const pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter((item) => {
        return (
          pattern.test(item.area) ||
          pattern.test(item.country) ||
          pattern.test(item.dial) ||
          pattern.test(item.iata)
        );
      });
    },
    openCustomerModal(item) {
      this.resetValidations();
      this.model = Object.assign({}, item);
      if (this.model.addresses && this.model.addresses.length > 0) {
        this.location = this.model.addresses[0].location;
      }
      $(this.$refs.customermodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    openMapModal(item) {
      document.getElementById("pac-input").value = "";
      this.resetValidations();
      if (
        this.location !== null &&
        this.location.latitude !== null &&
        this.location.longitude !== null
      ) {
        this.map.showMarker(
          new google.maps.LatLng(
            this.location.latitude,
            this.location.longitude
          )
        );
      } else {
        this.map.hideMarker();
      }
      $(this.$refs.mapmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeCustomerModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.customermodal).modal("hide");
    },
    closeMapModal() {
      $(this.$refs.mapmodal).modal("hide");
      $(this.$refs.customermodal).css("overflow-y", "auto");
    },
    openCustomerDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    openAuthModal(item) {
      this.resetValidations();
      this.auth = { id: item.id, password: null };
      $(this.$refs.customerpasswordmodal).modal();
    },
    closeAuthModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.customerpasswordmodal).modal("hide");
    },
    async submitAuth() {
      this.isSubmitted = true;
      this.$v.auth.$touch();
      if (this.$v.auth.$error) {
        return;
      }
      try {
        this.isLoading = true;
        await customerService.syncAuth(this.auth);
        this.$notification.success("Successfully synced.", {
          title: "Success",
        });
        this.closeAuthModal();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    createItem() {
      this.isUpdate = false;
      this.resetModel();
      this.activeTab = "general";
      this.openCustomerModal({
        companyId: this.defaultCompanyId,
        isAdmin: false,
        isPersonInCharge: false,
        title: "Mr",
        addresses: [],
        modifiedEmails: [
          {
            id: this.$helper.emptyGuid(),
            email: null,
            isMain: false,
            state: "Created",
          },
        ],
        modifiedPhones: [
          {
            id: this.$helper.emptyGuid(),
            code: null,
            number: null,
            isMain: false,
            state: "Created",
          },
        ],
      });
    },
    updateItem(item) {
      this.isUpdate = true;
      this.activeTab = "general";
      item.modifiedEmails = [];
      item.modifiedPhones = [];
      const dataModel = {
        ...item,
        title: this.findTitle(item.title, "title"),
        otherTitle: this.findTitle(item.title, "otherTitle"),
      };
      this.openCustomerModal(dataModel);
      for (let i = 0; i < this.model.emails.length; i++) {
        this.model.modifiedEmails.push({
          id: this.model.emails[i].id,
          email: this.model.emails[i].email,
          isMain: this.model.emails[i].isMain,
          state: "NoAction",
        });
      }
      for (let i = 0; i < this.model.phones.length; i++) {
        this.model.modifiedPhones.push({
          id: this.model.phones[i].id,
          code: this.model.phones[i].code,
          number: this.model.phones[i].number,
          isMain: this.model.phones[i].isMain,
          state: "NoAction",
        });
      }
    },
    findTitle(value, type) {
      const findTitle = this.titles.find((val) => val.value === value);

      if (type === "title") return findTitle ? value : "Other";
      else return findTitle ? null : value;
    },
    async getAllCompanies() {
      if (this.companies.length === 0) {
        this.companies = await companyService.getAllActive();
      }
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          filter += `&sort=${this.table.sort}&sortDir=${this.table.sortDir}`;
        }
        if (this.table.companyIds && this.table.companyIds !== "") {
          filter += `&companyIds=${this.table.companyIds}`;
        }
        if (this.table.type && this.table.type !== "") {
          filter += `&type=${this.table.type}`;
        }
        const response = await customerService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCompanies() {
      this.companies = await companyService.getAllActive();
    },
    async getPhoneCodes() {
      this.phoneCodes = await countryPhoneService.getAll();

      for (let i = 0; i < this.phoneCodes.length; i++) {
        const item = this.phoneCodes[i];
        item.label = `${item.iata} (+${item.dial})`;
        item.icon = `iti-flag ${item.iata.toLowerCase()}`;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.title =
          this.model.title === "Other"
            ? this.model.otherTitle
            : this.model.title;
        this.model.addresses = [];
        if (
          this.location.address !== null &&
          this.location.name !== null &&
          this.location.latitude !== null &&
          this.longitude !== null
        ) {
          this.model.addresses.push({
            location: this.location,
            isMain: true,
            state: "Created",
          });
        }
        this.model.isAdmin =
          this.model.isAdmin == "true" || this.model.isAdmin == true
            ? true
            : false;
        this.model.isPersonInCharge =
          this.model.isPersonInCharge == "true" ||
          this.model.isPersonInCharge == true
            ? true
            : false;
        this.model.emails = this.model.modifiedEmails.map((x) => x);
        this.model.phones = this.model.modifiedPhones.map((x) => x);
        if (this.isUpdate) {
          await customerService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await customerService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        this.closeCustomerModal();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await customerService.changeStatus({
          id: item.id,
          isActive: item.isActive,
        });
        if (item.isActive) {
          this.$notification.success("Successfully reactivated.", {
            title: "Success",
          });
        } else {
          this.$notification.success("Successfully deactivated.", {
            title: "Success",
          });
        }
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await customerService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printPhone(item) {
      return item && item.length > 0
        ? `(+${item[0].code}) ${item[0].number}`
        : "N/A";
    },
    printEmail(item) {
      return item && item.length > 0 ? `${item[0].email}` : "N/A";
    },
    addPhone() {
      this.model.modifiedPhones.push({
        id: this.$helper.emptyGuid(),
        code: null,
        number: null,
        isMain: false,
        state: "Created",
      });
    },
    removePhone(index) {
      this.model.modifiedPhones[index].state = "Deleted";
    },
    addEmail() {
      this.model.modifiedEmails.push({
        id: this.$helper.emptyGuid(),
        email: null,
        isMain: false,
        state: "Created",
      });
    },
    removeEmail(index) {
      this.model.modifiedEmails[index].state = "Deleted";
    },
    onChangeCustomerItem(item) {
      if (item.id === this.$helper.emptyGuid()) {
        item.state = "Created";
      } else {
        item.state = "Updated";
      }
    },
    async openCardModal(item) {
      await this.getListOfPaymentMethods(item);
      $(this.$refs.cardListModal).modal();
    },
    async getListOfPaymentMethods(item = "") {
      try {
        this.isLoading = true;
        this.selectedCustomerId =
          item && item.id ? item.id : this.selectedCustomerId;
        const response = await customerService.getListOfPaymentMethods(
          this.selectedCustomerId
        );
        if (response.isSuccess) {
          this.paymentList = response.data;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async openPaymentModal() {
      try {
        this.isLoading = true;
        const response = await customerService.getAirwallexClientSecret(
          this.selectedCustomerId
        );
        if (response.isSuccess) {
          this.awClientSecret = response.data;
          $(this.$refs.paymentModal).modal();
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async setDefaultCard(params) {
      try {
        this.isLoading = true;
        const payload = {
          id: params.id,
          paymentServiceCustomerId: params.paymentServiceCustomerId,
        };
        const response = await customerService.setDefaultPaymentMethod(payload);
        if (response.isSuccess) {
          this.paymentList = this.paymentList.map((val) => {
            if (val.id === params.id) return { ...val, isDefault: true };
            else return { ...val, isDefault: false };
          });
          this.$notification.success("Default card changed.", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async editCard(item) {
      this.isLoading = true;
      try {
        const response = await customerService.getPaymentMethodById(item.id);

        if (response.isSuccess) {
          this.selectedCard = {
            id: response.data.id,
            type: response.data.type,
            cardHolderName: response.data.cardHolderName,
          };
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        $(this.$refs.editCard).modal();
      }
    },
    async submitEditCard() {
      this.isLoading = true;
      try {
        const response = await customerService.updatePaymentMethod(
          this.selectedCard.id,
          this.selectedCard
        );
        if (response.isSuccess) {
          this.paymentList = this.paymentList.map((val) => {
            if (val.id === this.selectedCard.id)
              return {
                ...val,
                type: this.selectedCard.type,
                cardHolderName: this.selectedCard.cardHolderName,
              };
            else return { ...val };
          });
          this.$notification.success("Successfully changed card type.", {
            title: "Success",
          });
          $(this.$refs.editCard).modal("hide");
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    openDeleteCardModal(cardId) {
      this.selectedCardId = cardId;
      $("#deleteCardModal").modal();
    },
    async deleteCard() {
      try {
        this.isLoading = true;
        const response = await customerService.deletePaymentMethod(
          this.selectedCardId
        );
        if (response.isSuccess) {
          this.paymentList = this.paymentList.filter(
            (val) => val.id !== this.selectedCardId
          );
          this.$notification.success("Card deleted successfully.", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submitCardDetail() {
      this.getListOfPaymentMethods();
      $(this.$refs.paymentModal).modal("hide");
    },
    isExpired(expiryMonth, expiryYear) {
      const now = new Date();

      const expiryDate = new Date(
        parseInt(expiryYear),
        parseInt(expiryMonth),
        0,
        23,
        59,
        59
      );

      return now > expiryDate;
    },
    async openTokenizationLinkModal(customerId) {
      this.isLoading = true;
      try {
        const fetchTokenLink = await customerService.getTokenizationLink(
          customerId
        );

        if (fetchTokenLink.isSuccess) {
          this.$eventBus.$emit("TokenizationLinkModal", fetchTokenLink.data);
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/customer/Customer.vue